import ExtendableError from 'es6-error';

export default ExtendableError;
